import defaultStory from 'shared/components/story/storybook/default-story'
import getGifSkeleton from 'shared/components/gif-skeleton'

const placeholderUser = {
    avatar_url: '/static/img/new_story.png',
    display_name: 'Create Story',
    profile_url: '/create/story',
    username: 'createstory',
}

const placeholderCover = {
    gif: {
        ...getGifSkeleton(),
        images: {
            placeholder: {
                url: '/static/img/placeholder_story.gif',
            },
        },
    },
}

export default function(hasStories = false) {
    return {
        ...defaultStory,
        title: hasStories ? 'Create a New Story' : 'Create Your First Story',
        user: placeholderUser,
        cover_gif: placeholderCover,
        is_private: false,
        isCreateCard: true,
    }
}
